import { symbol } from "prop-types";
import styled from "styled-components";
import { deviceType } from "@tm/static/utils";
import { PersuasionBannerStyle } from "../../components/PersuasionBanner/PersuasionBanner.style";
import { ParaTagStyle } from "../../components/TextStyles/TextStyles.style";

export const ThankYouPageStyle = styled.div`
  background: #f6f6f6;
  position: relative;
  z-index: 1;
  padding-bottom: 20px;
  @media ${deviceType.mobile} {
    padding: 16px;
  }
  /* &:after {
        content: '';
        position: absolute;
        top: 0;
        width: 100%;
        background: #fff;
        height: 254px;
        z-index: -1;
    } */
`;

export const ThankYouPageWrap = styled.div`
  display: flex;
  gap: 20px;
  width: 1200px;
  margin: 0 auto;

  ${PersuasionBannerStyle} {
    margin: 0;
    @media ${deviceType.mobile} {
      margin-bottom: 16px;
      min-height: unset;
    }
  }
  @media ${deviceType.mobile} {
    flex-direction: column;
    width: 100%;
  }
`;

export const ThankYouPageHeadWrap = styled.div`
  padding-top: 25px;
  display: flex;
  background: #fff;
  @media ${deviceType.mobile} {
    padding: 80px 16px 20px;
  }
`;

export const ThankYouPageHead = styled.div`
  background: #fff;
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 48px;
  position: relative;
  @media ${deviceType.mobile} {
    padding-bottom: 0;
    width: 100%;
  }
  ${ParaTagStyle} {
    @media ${deviceType.mobile} {
      width: 64%;
    }
  }
`;

export const ThankYouPageLeft = styled.section`
  flex: 1;
  margin-top: -22px;
`;

export const ThankYouPageRight = styled.section`
  width: 300px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: -22px;
  @media ${deviceType.mobile} {
    width: 100%;
  }
`;

export const ThankYouMwebStyle = styled.div`
  background: #f2f2f2;
  padding: 1px 16px 16px;
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  position: relative;
`;

export const FlightUpcomingWrap = styled.div`
  align-self: flex-end;
  position: absolute;
  right: 0;
  bottom: 0px;
  display: flex;
  @media ${deviceType.mobile} {
    width: 150px;
    height: 80px;
    bottom: -20px;
  }
`;

export const PendingStatusTag = styled.div`
  background: linear-gradient(88.04deg, #c06d0c 0%, #f2c21a 100%);
  border-radius: 16px;
  margin-bottom: 8px;
  color: #fff;
  text-transform: uppercase;
  font-size: 12px;
  line-height: 16px;
  padding: 2px 8px;
  margin-bottom: 8px;
  width: fit-content;
  font-weight: 700;
`;
